var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('demo',{attrs:{"name":"choice","title":"Choice","markup":_vm.markup}},[_c('template',{slot:"intro"},[_c('p',[_vm._v("Choice is a common name for Checkboxes and Radio buttons.")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }